import { Route } from "@/routes/__root";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useClient } from "creso-core/hooks";
import { omit } from "radash";
import { RiskProfiler, RiskProfileTier } from "web-core";
import { Dialog, DialogContent } from "web-design-system";
import { IntroStep } from "./intro-step";

export function RiskProfilerDialog() {
  const { client_id } = useSearch({ from: Route.id });

  const { refetch, data: client } = useClient(client_id as number);

  const navigate = useNavigate();

  const onOpenChange = (open: boolean) => {
    if (open) return;
    navigate({
      to: ".",
      search: (prev) => omit(prev, ["modal", "client_id"]),
      replace: true,
    });
  };

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent className="h-180 max-h-[85vh] w-120 p-5">
        <RiskProfiler
          onComplete={() => refetch()}
          onClose={() => onOpenChange(false)}
          clientId={client_id as number}
          initialTier={client?.risk_profile as RiskProfileTier | null}
          IntroComponent={(props) => (
            <IntroStep {...props} clientId={client?.id as number} />
          )}
          HeaderComponent={() => (
            <div className="flex items-center justify-between pb-4">
              <span className="text-lg font-semibold text-foreground">
                Risk Assessment
              </span>
            </div>
          )}
        />
      </DialogContent>
    </Dialog>
  );
}
